import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Avatar, Box, Modal, TableBody } from "@mui/material";
import { useLazyQuery, useMutation } from "@apollo/client";
import CreateBlog from "../../components/blogs/CreateBlog";
import { ALL_MUSCLES_TYPES, POSITION } from "../../gql/muscleTypes";
import {
  LoadingModal,
  DataTable,
  DataTableCell,
  DataTablePagination,
  DataTableRow,
  ListPageLayout,
  RowActions,
} from "../../components/layout";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100vw",
  height: "100vh",
  overflow: "scroll",
  bgcolor: "background.paper",
  boxShadow: 24,
};

const MUSCLE_COLUMNS = [
  { id: "id", label: "ID", minWidth: 60 },
  { id: "image", label: "Image", minWidth: 80 },
  { id: "name", label: "Name", minWidth: 160 },
  { id: "created", label: "Created At", minWidth: 120 },
  { id: "actions", label: "Action", minWidth: 140 },
];

const MuscleTypes = () => {
  const navigate = useNavigate();

  const [count, setCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [offset, setOffset] = useState(0);
  const [blogs, setBlogs] = useState(null);
  const [createOpen, setCreateOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [searchValue, setSearchValue] = useState("");

  const [loadMucleTypes, result] = useLazyQuery(ALL_MUSCLES_TYPES);

  const [updatePosition] = useMutation(POSITION, {
    onError: (error) => {
      console.log("error: ", error);
    },
    onCompleted: () => {
      alert("Muscle Type have been put to the top.");
    },
    refetchQueries: [ALL_MUSCLES_TYPES],
  });

  useEffect(() => {
    loadMucleTypes({
      variables: {
        limit: rowsPerPage,
        offset: offset,
        search: `%${search}%`,
      },
      fetchPolicy: "network-only",
    });
  }, [loadMucleTypes, offset, search, rowsPerPage]);

  useEffect(() => {
    if (result.data) {
      setBlogs(result.data.muscle_types);
      setCount(Number(result.data?.muscle_types_aggregate.aggregate.count));
    }
  }, [result]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setOffset(rowsPerPage * newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    setOffset(0);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setSearch(searchValue);
    setPage(0);
    setOffset(0);
    if (searchValue === "") {
      loadMucleTypes();
    }
  };

  if (!blogs) {
    return <LoadingModal open message="Loading..." />;
  }

  return (
    <>
      <ListPageLayout
        breadcrumbs={[
          { label: "Dashboard", to: "/user" },
          { label: "Muscle Type" },
        ]}
        title="Muscle Types"
        subtitle="Manage muscle type categories and ordering."
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearchSubmit={handleSearch}
        searchPlaceholder="Search by title"
        showFilters={false}
        createLabel="Add"
        onCreateClick={() => navigate("/createMuscleType")}
      >
        <DataTable
          columns={MUSCLE_COLUMNS}
          isEmpty={blogs.length === 0}
          emptyMessage="No Muscle Types Data"
        >
          <TableBody>
            {blogs.map((row, index) => (
              <DataTableRow key={row.id}>
                <DataTableCell>{page * rowsPerPage + index + 1}</DataTableCell>
                <DataTableCell>
                  <Avatar
                    alt="muscle type"
                    src={row?.image_url}
                    sx={{ width: 56, height: 56 }}
                  />
                </DataTableCell>
                <DataTableCell>{row?.name}</DataTableCell>
                <DataTableCell>{row?.created_at.substring(0, 10)}</DataTableCell>
                <DataTableCell>
                  <RowActions
                    onView={() => navigate(`/muscleType/${row.id}`)}
                    viewLabel="Detail"
                    menuItems={[
                      {
                        label: "Put to Top",
                        onClick: () =>
                          updatePosition({
                            variables: {
                              id: row.id,
                              updated_at: new Date().toISOString(),
                            },
                          }),
                      },
                    ]}
                  />
                </DataTableCell>
              </DataTableRow>
            ))}
          </TableBody>
        </DataTable>

        <DataTablePagination
          count={count}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[10, 25, 100]}
          entityLabel="muscle types"
        />
      </ListPageLayout>

      <Modal
        keepMounted
        open={createOpen}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box style={style}>
          <CreateBlog />
        </Box>
      </Modal>
    </>
  );
};

export default MuscleTypes;
